import React, { useEffect, useState } from 'react'
import "./Experience.css"
import useLocalStorage from 'use-local-storage';


import { FaLocationDot } from "react-icons/fa6";

import { MdOutlineFileDownload } from "react-icons/md";
import { FaDev } from "react-icons/fa";
import { FaMobile } from "react-icons/fa";
import { MdIntegrationInstructions } from "react-icons/md";
import { MdModelTraining } from "react-icons/md";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { MdDateRange } from "react-icons/md";
import { IoCheckmarkCircle } from "react-icons/io5";

import Footer1 from '../footer/Footer1';
import BackToTop from '../BackToTop';
import Marque from '../Marque';
import Navbar from '../navbar/Navbar';



const Experience = () => {

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        },1000);        
    },[])

    const [theme, ] = useLocalStorage('theme' ? 'dark': 'light')

    //  const themeSwitch = () => {
    //     const newTheme = theme === 'light' ? 'dark' : 'light';
    //      setTheme(newTheme)
    //  }
  
    // useEffect(() => {
    //     AOS.init();
    // },[])


  return (
    <>
        {
            isLoading ? (
                <div className="load" data-theme={theme}><hr/><hr/><hr/><hr/></div>
            ) : (
                <div className='experience_container'>
                    <Navbar />
                    <div className='experience_inner_div'>
                        <div className='first_experience_div'>
                            <h1>Professional <span>Experience</span></h1>
                            <p>Here is my Journey in Software Engineering, Solving complex UI problems for entreprises and users.</p>

                            <a href="UCHENNA AKUBUE RESUME.pdf" download>
                                <button className='resume__btn'><MdOutlineFileDownload /> Download Resume</button>
                            </a>
                        </div>

                        <div className='second_experience_div'>
                            <div className='sec_experience_1'>
                                <FaDev className='react__icon' />
                                <h3>Web Development</h3>
                                <p>Creating mobile-friendly user interfaces to enhance interactivity.</p>
                            </div>

                            <div className='sec_experience_1'>
                                <FaMobile className='react__icon' />
                                <h3>Mobile app development</h3>
                                <p>Designing fully functional mobile applications that cater to market requirements.</p>
                            </div>

                            <div className='sec_experience_1'>
                                <MdIntegrationInstructions className='react__icon' />
                                <h3>Api Integration</h3>
                                <p>Connecting RESTful APIs for enhanced performance.</p>
                            </div>

                            <div className='sec_experience_1'>
                                <MdModelTraining className='react__icon' />
                                <h3>Training</h3>
                                <p>Offer training programs for entry-level developers</p>
                            </div>
                        </div>

                        <div className='third_experience_div'>
                            <div className='first_experience_div'>
                                <h1>My Professional <span>Journey</span></h1>
                                <p>A timeline of my career growth and the impactful projects that have shaped my expertise in Web Development</p>
                            </div>

                            <div className='work_experience_div'>
                                
                                <div className='work_inner_div_2'>
                                    <div className='career__div_left'></div>
                                    <div className='career__div_right'>
                                        <div className='period_sec'>
                                            <MdDateRange /><span>April 2025 - Present</span> 
                                        </div>
                                        <h3>Front-End Engineer [Remote]</h3>
                                        <p className='exp_company_name'><HiOutlineBuildingOffice /><span><a href='https://www.linkedin.com/company/payedge/posts/?feedView=all' className="emploCompName">PayEdge</a></span> </p>
                                        <p className='company_location_1'><FaLocationDot /><small>Los Angeles, United States</small></p>
                                        <div className='work_desc_div_right'>
                                            <div className='role_div_right pb-4'>
                                                {/* <span className='checker'><IoCheckmarkCircle /></span> */}
                                                <span>PayEdge is a digital platform that empowers businesses to accelerate payments,
                                                     build stronger partnerships, and scale efficiently through seamless financial 
                                                     interactions. 
                                                </span>  
                                            </div>
                                            <hr />
                                            <p className='pt-4'>As a Front-End Engineer, my key contributions include:</p>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>
                                                    Building responsive and accessible UI screens using modern web 
                                                    technologies to ensure optimal performance across devices and platforms
                                                </span>  
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>
                                                    Integrating RESTful APIs and third-party services to enable real-time 
                                                    data exchange and smooth application workflows
                                                </span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>Collaborating cross-functionally with designers, backend developers, 
                                                    and product managers to align technical implementation with business goals
                                                </span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>
                                                    Contributing creative ideas and solutions during team discussions and sprint planning to 
                                                    continuously improve user experience and product efficiency
                                                </span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>
                                                    Writing clean, maintainable code and participating in code reviews to uphold quality and consistency
                                                </span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>
                                                    Ensuring scalability and reusability by developing modular, well-structured components and maintaining design system adherence
                                                </span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>
                                                    Using version control (Git) for efficient team collaboration and continuous integration workflows
                                                </span>
                                                
                                            </div>
                                        </div>
                                        <div className='dev__tools_right'>
                                            <p>React</p>
                                            <p>Redux</p>
                                        </div>
                                    </div>
                                </div>


                                <div className='work_inner_div'>
                                    <div className='career__div_1'>
                                        <div className='period_sec'>
                                        <MdDateRange className='unstable_icon' /><span>April 2025 - Present</span> <MdDateRange className='stable_icon'/>
                                        </div>
                                        <h3>Front-End Engineer [Full-Time]</h3>
                                        <p className='exp_company_name'><HiOutlineBuildingOffice className='unstable_icon' /><span><a href='https://www.linkedin.com/company/activedgetechnologies/posts/?feedView=all' className="emploCompName">ActivEdge Technologies Limited</a></span> <HiOutlineBuildingOffice className='stable_icon' /></p>
                                        <p className='company_location_1'><FaLocationDot className='unstable_icon' /><small>Lagos, Nigeria</small> <FaLocationDot className='stable_icon' /></p>
                                        <div className='work_desc_div'>
                                            <div className='role_div'>
                                                <span>Building modern, scalable web applications with a strong emphasis on responsive
                                                    design and cross-browser compatibility. Leveraging React, Angular, Redux Toolkit, 
                                                    and TypeScript to craft dynamic user interfaces for a seamless user experience.
                                                </span>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                            </div>

                                            <div className='role_div'>
                                                <span>API Integration: Seamlessly integrated REST APIs to facilitate efficient 
                                                    data exchange between the front-end and back-end, optimizing performance 
                                                    and reliability. 
                                                </span>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                            </div>

                                            <div className='role_div'>
                                                <span>Collaboration & Code Review: Working closely with designers and backend developers to deliver 
                                                    well-structured, cohesive projects. Conducting regular code reviews and enforcing best practices 
                                                    using ESLint and Prettier.
                                                </span>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                            </div>
                                        </div>
                                        <div className='dev__tools'>
                                            <p>React</p>
                                            <p>Redux</p>
                                        </div>
                                    </div>
                                    <div className='career__div_2'></div>
                                </div>

                                <div className='work_inner_div_2'>
                                    <div className='career__div_left'></div>
                                    <div className='career__div_right'>
                                        <div className='period_sec'>
                                            <MdDateRange /><span>August 2024 - Present</span> 
                                        </div>
                                        <h3>Front-End Engineer [Part-Time]</h3>
                                        <p className='exp_company_name'><HiOutlineBuildingOffice /><span><a href='https://www.linkedin.com/company/decode-investing/posts/?feedView=all' className="emploCompName">Decode Investing Limited </a></span> </p>
                                        <p className='company_location_1'><FaLocationDot /><small>New Jersey, United States</small></p>
                                        <div className='work_desc_div_right'>
                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>Responsive Web Application Development: Building modern, scalable
                                                     web applications with a strong emphasis on responsive design and 
                                                     cross-browser compatibility. Leveraging React, Redux Toolkit, and 
                                                     TypeScript to craft dynamic user interfaces for a seamless user 
                                                     experience. 
                                                </span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>API Integration: Seamlessly integrated REST APIs to facilitate efficient 
                                                    data exchange between the front-end and back-end, optimizing performance 
                                                    and reliability. 
                                                </span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>Collaboration & Code Review: Working closely with designers and backend developers to deliver 
                                                    well-structured, cohesive projects. Conducting regular code reviews and enforcing best practices 
                                                    using ESLint and Prettier.
                                                </span>
                                                
                                            </div>
                                        </div>
                                        <div className='dev__tools_right'>
                                            <p>React</p>
                                            <p>Ruby on Rails</p>
                                        </div>
                                    </div>
                                </div>


                                <div className='work_inner_div'>
                                    <div className='career__div_1'>
                                        <div className='period_sec'>
                                            <MdDateRange className='unstable_icon' /><span>October 2023 - November 2024</span> <MdDateRange className='stable_icon'/>
                                        </div>
                                        <h3>Web Developer [Intern]</h3>
                                        <p className='exp_company_name'><HiOutlineBuildingOffice className='unstable_icon' /><span>Gigo Planet Services Limited</span> <HiOutlineBuildingOffice className='stable_icon'/></p>
                                        <p className='company_location_1'><FaLocationDot className='unstable_icon' /><small>Enugu, Nigeria</small> <FaLocationDot className='stable_icon' /></p>
                                        <div className='work_desc_div'>
                                            <div className='role_div'>
                                                <span>Documented technical workflows and knowledge to educate newly hired employees.
                                                    Worked closely with peers to identify issues and provide suitable resolutions.
                                                    Developed reports using SQL server reporting services.
                                                    Worked with design teams and Senior Software Engineers to build customized software products for consumers.
                                                </span>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                            </div>

                                            <div className='role_div'>
                                                <span>API Integration: Seamlessly integrated REST APIs to facilitate efficient 
                                                    data exchange between the front-end and back-end, optimizing performance 
                                                    and reliability. 
                                                </span>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                            </div>

                                            <div className='role_div'>
                                                <span>    Wrote clear, clean code for various projects.
                                                        Partnered with team members to learn best practices in software design.
                                                        Tested new applications for usability and adherence to code plan.
                                                        worked with design teams and Senior Software Engineers to build customized software products for consumers. 
                                                </span>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                            </div>
                                        </div>
                                        <div className='dev__tools'>
                                            <p>Git</p>
                                            <p>React</p>
                                            <p>Tailwind Css</p>
                                        </div>
                                    </div>
                                    <div className='career__div_2'></div>
                                </div>

                                <div className='work_inner_div_2'>
                                    <div className='career__div_left'></div>
                                    <div className='career__div_right'>
                                        <div className='period_sec'>
                                            <MdDateRange /><span>August 2023 - September 2023</span> 
                                        </div>
                                        <h3>Programming Instructor [Contract]</h3>
                                        <p className='exp_company_name'><HiOutlineBuildingOffice /><span>ICT/Innovation Center University of Nigeria Nsukka</span> </p>
                                        <p className='company_location_1'><FaLocationDot /><small>Enugu, Nigeria</small> </p>
                                        <div className='work_desc_div_right'>
                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>Mentored Attendees in computer programming and coding, resulting in a 76% increase in student participation in computer science competitions
                                                </span>                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>Developed and implemented a comprehensive training program that improved tech knowledge by 62%
                                                Implemented a single-page application using React and React Context API that improved overall performance and usability
                                                </span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>Utilized HTML5, CSS, and JavaScript to create a dynamic, interactive user interface to give a more comprehensive instance for trainees</span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>    Advised students on matters regarding academic performance and careers in computer science.
                                                    Mentored Attendees in computer programming and coding, resulting in a 76% increase in student participation in 
                                                    computer science competitions    Attended professional 
                                                    development technology courses 
                                                    to increase knowledge base and learn new information. Advised students on matters regarding academic
                                                     performance and careers in computer science.
                                                </span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>Utilized version control systems such as Git to manage code changes and collaborate with 
                                                other developers</span>
                                                
                                            </div>

                                            <div className='role_div_right'>
                                                <span className='checker'><IoCheckmarkCircle /></span>
                                                <span>Help startups by educating them how to write clean code for various projects.</span>
                                                
                                            </div>
                                        </div>
                                        <div className='dev__tools_right'>
                                            <p>HTML5</p>
                                            <p>CSS3</p>
                                            <p>Javascript</p>
                                            <p>GIT / GITHUB</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Marque />
                    <Footer1 />
                    <BackToTop />
                </div>
            )
        }
    </>
  )
}

export default Experience